import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
} from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import styles from "../style";

interface Props {
  title: string;
  img: string;
  classes?: any;
}
const CardImg = (props: Props) => {
  const { title, img, classes } = props;
  return (
    <Card className={classes.containerCard}>
      <CardMedia className={classes.cardImg} image={img} title={title} />
      <CardContent className={classes.cardTitle}>{title}</CardContent>
    </Card>
  );
};

export default withStyles(styles)(CardImg);
